import React from "react";
import {Link} from "react-router-dom";

const PageTitle = ({title}) => {
    return (
        <>
            <div style={{height: 110, display: "none"}}/>

            <section className="page-header">
                <div
                    className="page-header__bg"
                    style={{backgroundImage: "url(assets/img/bg/page-header-bg.jpg)"}}
                ></div>
                <div className="container">
                    <div className="page-header__inner">
                        <h2>{title}</h2>
                        <ul className="thm-breadcrumb">
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <span>/</span>
                            </li>
                            <li>{title}</li>
                        </ul>
                    </div>
                </div>
            </section>

        </>
    );
};

export default PageTitle;
